import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  Button,
  TranslationProvider,
} from '@resy/ui-kitchen';
import './ButtonDropdown.scss';

const ButtonDropdown = ({ links, testId, toggleButton }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <div
      className="ButtonDropdown"
    >
      <div>
        <TranslationProvider
          translationKey={toggleButton.translationKey}
        >
          <Button
            data-test-id={`${testId}-button-open_dropdown`}
            onClick={toggleOpen}
            className="ResyForm__button ResyForm__button--outline Button--sm ButtonDropdown__toggle-button"
          >
            {toggleButton.text}
          </Button>
        </TranslationProvider>
      </div>
      <div className={cx('ButtonDropdown__Links', { 'ButtonDropdown__Links--visible': isOpen })}>
        {links.map((link, index) => (
          <div className="ButtonDropdown__Link" key={link.props.translationKey || `button-dropdown-${index}`}>
            {link}
          </div>
        ))}
      </div>
    </div>
  );
};

ButtonDropdown.propTypes = {
  links: PropTypes.arrayOf(PropTypes.node).isRequired,
  testId: PropTypes.string.isRequired,
  toggleButton: PropTypes.shape({
    translationKey: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
};

export default ButtonDropdown;
